export const parcelDebtsollectionGuard = 'GET /parceldebts';
export const parcelDebtResourceGuard = 'GET /parceldebts/d+';
export const addParcelDebtResourceGuard = 'POST /parceldebts';
export const editParcelDebtResourceGuard = 'PUT /parceldebts/d+';
export const deleteParcelDebtResourceGuard = 'DELETE /parceldebts/d+';
